import { EVENTS } from '../../../../../app/constants/events';

xplenty.controller('SchemaImporterStep', [
  '$scope',
  '$translate',

  function ($scope, $translate) {
    $scope.schemaImporterStep = $scope.$parent.createStep(
      $translate.instant(`component-editor.step-schema.${$scope.component.componentType}.closed`),
      $translate.instant(`component-editor.step-schema.${$scope.component.componentType}.active`),
      '<schema-importer component="component" has-error="schemaImporterStep.error" selected-fields="selectedFields" valid="schemaImporterStep.valid" variables="variables" />',
    );

    $scope.schemaImporterStep.validate = function () {
      if (this.valid) {
        this.tags = _.map($scope.selectedFields, function (field) {
          return {
            name: field.alias,
          };
        });
      } else {
        this.tags = [];
      }
      return this.valid;
    };

    $scope.$on(EVENTS.SCHEMA_IMPORTER_LOADING_STARTED, function () {
      $scope.schemaImporterStep.loading = true;
      $scope.schemaImporterStep.valid = false;
    });

    $scope.$on(EVENTS.SCHEMA_IMPORTER_LOADING_ENDED, function () {
      $scope.schemaImporterStep.loading = false;
      $scope.schemaImporterStep.validate();
    });
  },
]);
